import { IsNotEmpty } from "class-validator";

export class AccountLinkDto {
  @IsNotEmpty()
  return_url: string;

  @IsNotEmpty()
  refresh_url: string;
}
